export const cloudinaryTransform = (thumbnailURL, mods) => {
  if (thumbnailURL.includes('res.cloudinary.com') && !thumbnailURL.includes('c_fill')) {
    const extractedPublicId = thumbnailURL.split('upload/');
    return `${extractedPublicId[0]}upload/${mods.join('/')}/${extractedPublicId[1]}`;
  }
  return thumbnailURL;
};

export const fullTransform = (src: string) => {
  if (typeof src === 'string') {
    return cloudinaryTransform(src, [
      't_lpr-full-transform',
      'f_auto,q_auto',
    ]);
  }
  return src;
};
